import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, ComponentPublicInstance } from "vue";
import { WorkSchedule } from "../UserMasterWorkSchedule";
import WorkScheduleForm from "./WorkScheduleForm.vue";

type Props = {
  affiliationId?: number;
  items: WorkSchedule[];
};
type Emits = {
  (e: "input", value: boolean): void;
  (e: "click", val: WorkSchedule): void;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'WorkScheduleDialogRegist',
  props: {
    affiliationId: null,
    items: null
  },
  emits: ["input", "click"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "input", value: boolean): void;
  (e: "click", val: WorkSchedule): void;
}), expose: any, slots: any, attrs: any }) {




const initForm: WorkSchedule = {
  week1: "1",
  week2: "1",
  week3: "1",
  week4: "1",
  week5: "1"
};

const isOpen = ref(false);

const vform = ref<ComponentPublicInstance<typeof WorkScheduleForm>>();
const item = ref<WorkSchedule>({});

const onClose = () => {
  isOpen.value = false;
};
const onClick = () => {
  if (!vform.value?.validate()) return;
  onClose();
  emits("click", item.value);
};

watch(
  isOpen,
  () => {
    item.value = Object.assign({}, initForm);
  },
  { immediate: true }
);

return { __sfc: true,emits, initForm, isOpen, vform, item, onClose, onClick, WorkScheduleForm }
}

})